import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Allows access only if a token was passed in route state.
 * No token → redirect to /admin every time.
 */
const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const token = location.state?.token;         // token lives only in memory
  return token ? children : <Navigate to="/admin" replace />;
};

export default PrivateRoute;
